/**
 * La preferencia y el tema, siempre al día.
 *
 * `useSyncExternalStore` por lo mismo que `useAccent`: se elige desde el menú de
 * la cuenta y lo pinta la aplicación, y la verdad está en la cookie, no en
 * ningún componente. El tema, además, cambia solo con «automático».
 */
import { useSyncExternalStore } from 'react';
import { DEFAULT_THEME_PREFERENCE, readTheme, readThemePreference, subscribeTheme, } from './theme';
export function useThemePreference() {
    return useSyncExternalStore(subscribeTheme, readThemePreference, () => DEFAULT_THEME_PREFERENCE);
}
export function useResolvedTheme() {
    return useSyncExternalStore(subscribeTheme, readTheme, () => 'light');
}
//# sourceMappingURL=useTheme.js.map